var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isCreated
    ? _c(
        "div",
        {
          ref: "root",
          staticClass: "c-custom-bundle__categories",
          attrs: { id: "v-categories" },
        },
        [
          _c("div", { staticClass: "c-custom-bundle__categories__title" }, [
            _vm._v("Podlaha"),
          ]),
          _vm._v(" "),
          _vm.selectedCategoryId
            ? _c("div", { staticClass: "c-custom-bundle__categories__back" }, [
                _vm.showBackButton
                  ? _c(
                      "button",
                      {
                        staticClass: "c-btn c-btn--primary",
                        attrs: { title: _vm.backButtonName },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.back.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "ico ico-chevron-left is-on-left",
                        }),
                        _vm._v(" " + _vm._s(_vm.backButtonName) + "\n    "),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-custom-bundle__categories__categories" },
            _vm._l(_vm.categories, function (category) {
              return _c(
                "a",
                {
                  key: category.id,
                  staticClass: "c-custom-bundle__category-item",
                  class: {
                    "is-active": category.id == _vm.selectedCategoryId,
                  },
                  attrs: {
                    href: category.link,
                    title: category.menu_name
                      ? category.menu_name
                      : category.name,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.change(category.id)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "c-custom-bundle__category-item__title" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            category.menu_name
                              ? category.menu_name
                              : category.name
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "c-custom-bundle__category-item__count" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(category.products_count) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }